import { resolveVariantFromProps } from "./resolve-variants";
export function resolveVariant(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}
//# sourceMappingURL=resolve-dynamic-variants.js.map